import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';
import { ICON_SERVICE_PROVIDER } from './icon.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [IconComponent],
  exports: [IconComponent],
  providers: [ICON_SERVICE_PROVIDER],
})
export class IconModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/ui/icon/icon.module.ts